export const zIndex = {
  snackbar: 5,
  screenCover: 4,
  menu: 7,
  popover: 6,
} as const;
